const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/Footer/Footer.tsx';
import { ReactNode, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { css, cx } from '@emotion/css';

interface Props {
    children?: ReactNode;
    className?: string;
    type?: 'primary' | 'secondary'; // secondary is for when the Footer is not at the bottom of the screen or page
}

function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => css`
            flex: 0 0 auto; // ideally not here...

            position: relative;

            display: flex;
            align-items: flex-start;
            justify-content: flex-end;
            gap: ${theme.spacing(1)};

            min-height: ${theme.spacing(10)};
            padding: ${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(3)};

            &.secondary {
                height: auto;
                min-height: auto;
                padding: ${theme.spacing(1)} ${theme.spacing(2)};
            }
        `,
        [theme]
    );
}

export const Footer = (props: Props) => {
    const { type = 'primary' } = props;
    const className = useCSSClasses();
    return <div className={cx('Footer', type, className, props.className)}>{props.children}</div>;
};
